import { EventHandler, SyntheticEvent } from "react";

export const getOffset = (element: any) => {
    if (!element.getClientRects().length) {
        return { top: 0, left: 0 };
    }

    const rect = element.getBoundingClientRect();
    const win = element.ownerDocument.defaultView;
    return {
        top: rect.top + win.pageYOffset,
        left: rect.left + win.pageXOffset
    };
};

export const applyConditionalClasses =
    (condition: () => boolean, element?: HTMLElement | null) =>
    ({ ifTrue, ifFalse }: { ifTrue: string; ifFalse: string }) => {
        const isConditionMet = condition();

        element?.classList.toggle(ifTrue, isConditionMet);
        element?.classList.toggle(ifFalse, !isConditionMet);
    };

export const preventUntrusted =
    <TEvent extends SyntheticEvent>(eventHandler?: EventHandler<TEvent>) =>
    (event: TEvent) => {
        if (!event.isTrusted) {
            event.preventDefault();
            return;
        }

        return eventHandler?.(event);
    };
